import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, IcoArchive, IcoDownload, PopoverCentralAjuda, SafeHTML } from '../../../components';
import { CustomLabel, CustomTooltip, RenderLegend, colors, graficoOptions } from './graficoOptions';
import { Bar, BarChart, Brush, CartesianGrid, Cell, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { BarCustom, CustomTooltipCustom, PageLoadView, RenderLegendCustom, convertChart } from '../../../helpers';

export default ({ nlsContexto, labelgraf, nls, imprimir }) => {
  const dispatch = useDispatch()
  const { projeto, grafico, graficoLoad } = useSelector(state=> state.rankingcsatState)
  const { titlePage } = useSelector(state=> state.layoutState)
  const [download, setDownload] = useState(false)

  const idarray = [206];


  const handleDownload = async (e) => {
    setDownload(true)
    const chartdownload = await convertChart({id: 'graficos-chart-box', titlePage})
    setDownload(chartdownload)
  }



  return (
    <>
      <div
  id='graficos-chart-box'
  data-cy='csatstorescompetitors-result'
  className={`box-rankingcsat-graficos box-content ${download?'graficos-download':''}`}
>
        <div className='graficos-chart-box-action'>
          <PopoverCentralAjuda cy='help' nlsContexto={nlsContexto} idarray={idarray} />       
          {!graficoLoad?<Button data-cy='chart-download' type='btn circle' color='primary' variant='outlined' onClick={()=> handleDownload()} title={nls.downloadgrafico}><IcoDownload /></Button>:null}
        </div>
        <div id='graficos-chart' data-cy='csatstorescompetitors-chart' className="box-rankingcsat-graficos-chart">
          <h3>{titlePage}</h3>
          <PageLoadView
           load={graficoLoad} 
           data={grafico.data}
           semdadosparaexibir={!imprimir ? nls.semdadosparaexibir : null}
          >
            {imprimir ? (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                width={graficoOptions.BarChart.width}
                height={graficoOptions.BarChart.height}
                data={grafico.data}
                margin={graficoOptions.BarChart.margin}
              >
                <CartesianGrid
                  stroke={graficoOptions.CartesianGrid.stroke} 
                  vertical={graficoOptions.CartesianGrid.vertical} 
                />
                {
                  grafico.data && !(grafico.data.length <= graficoOptions.Brush.endIndex)?
                  <Brush
                    dataKey={graficoOptions.Brush.dataKey} 
                    height={graficoOptions.Brush.height} 
                    stroke={graficoOptions.Brush.stroke} 
                    startIndex={graficoOptions.Brush.startIndex}
                    endIndex={graficoOptions.Brush.endIndex}
                  />
                  :null
                }
                <XAxis 
                  dataKey={graficoOptions.XAxis.dataKey} 
                  stroke={graficoOptions.XAxis.stroke} 
                  axisLine={graficoOptions.XAxis.axisLine} 
                  tickLine={graficoOptions.XAxis.tickLine} 
                  fontSize={graficoOptions.XAxis.fontSize} 
                />
                <YAxis 
                  unit={graficoOptions.YAxis.unit} 
                  stroke={graficoOptions.YAxis.stroke} 
                  axisLine={graficoOptions.YAxis.axisLine} 
                  tickLine={graficoOptions.YAxis.tickLine} 
                  fontSize={graficoOptions.YAxis.fontSize} 
                />
                {/* <Tooltip content={<CustomTooltip labels={grafico.labels} />} />
                <Legend content={<RenderLegend  labels={grafico.labels} />} /> */}
                {/* {
                  grafico.labels?.map((label, i)=> <Bar 
                    key={`bar-${label.type}-${i}`}
                    dataKey={label.type} 
                    fill={label.color} 
                    radius={graficoOptions.Bar.radius} 
                    label={<CustomLabel />}
                  />)
                } */}
                
                
                <Tooltip content={<CustomTooltipCustom labels={grafico.labels} msgNA={nls.Dadonaodisponivel} labelgraf={labelgraf} exibirPercentual={true}/>} />
                <Legend content={<RenderLegendCustom  labels={grafico.labels} />} />

                <Bar
                  dataKey="Atual"
                  fill="Atual"
                  radius={graficoOptions.Bar.radius} 
                  label={<CustomLabel />}
                  shape={<BarCustom />}
                />
                <Bar
                  dataKey="Anterior"
                  fill="Anterior"
                  radius={graficoOptions.Bar.radius} 
                  label={<CustomLabel />}
                  shape={<BarCustom />}
                />
              </BarChart>
            </ResponsiveContainer>
          ) : null}
          </PageLoadView>
        </div>

        {imprimir && (
          <div
  className="box-rankingcsat-graficos-chart-info"
  data-cy='ranking-stats'
>
  <span
  data-cy='ranking-mean'
  data-cy-value={grafico.media}
>
  <strong>{nls.media} </strong> {grafico.media}
</span>
<span
  data-cy='ranking-stddev'
  data-cy-value={grafico.desvio}
>
  <strong>{nls.desviopadrao} </strong> {grafico.desvio}
</span>
</div>
        )}


      </div>
      {
        imprimir && grafico.analiseGrafica?
        <div className='box-rankingcsat-analise-grafica box-content' data-cy='csatstorescompetitors-analysis'>
          <h3><IcoArchive/>  {nls.analise}</h3>

          {/* Substituído dangerouslySetInnerHTML pelo componente SafeHTML */}
          <SafeHTML html={grafico.analiseGrafica} />
        
        </div>
        :null
      }
    </>
  )
}
